import defaultMatchTimes from "../constants/DefaultMatchTimes";

export const getMatchDuration = (tournament, poulesByKey, match) => {
  let poule = poulesByKey[match.poule] || {};
  let elementId = match.poule;
  if (poule.bracket) {
    elementId = poule.bracket;
  }
  let elementDuration = (tournament.customMatchDuration || {})[elementId] || "";
  let divisionDuration =
    (tournament.customMatchDuration || {})[poule.division] || "";
  let duration =
    match.duration ||
    elementDuration ||
    divisionDuration ||
    tournament.matchDuration ||
    defaultMatchTimes.matchDuration;
  return duration;
};
